/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserMeInfo = {
  properties: {
    email: {
      type: 'string',
      isRequired: true,
    },
    phone: {
      type: 'string',
      isRequired: true,
    },
    person: {
      type: 'Person',
    },
    professional: {
      type: 'Professional',
    },
    workflow: {
      type: 'UserWorkflowBasic',
    },
  },
} as const;
